import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import styles from "./header.module.css";
import useTranslation from "next-translate/useTranslation";

var Index = function Index() {
  var _useTranslation = useTranslation(),
      t = _useTranslation.t,
      lang = _useTranslation.lang;

  return /*#__PURE__*/_jsxs("div", {
    className: styles.wrapper,
    children: [/*#__PURE__*/_jsxs("div", {
      className: styles.header,
      children: [/*#__PURE__*/_jsx("h4", {
        className: styles.headerTop,
        children: t('aboutUs:about-us')
      }), /*#__PURE__*/_jsx("h4", {
        className: styles.headerMiddle,
        children: t('aboutUs:intro')
      }), /*#__PURE__*/_jsx("p", {
        className: styles.headerBottom,
        children: t('aboutUs:why-wow')
      })]
    }), /*#__PURE__*/_jsxs("div", {
      className: styles.pedagogy,
      children: [/*#__PURE__*/_jsx("h4", {
        className: styles.pedagogyTop,
        children: t('aboutUs:wow-pedagogy')
      }), /*#__PURE__*/_jsx("p", {
        className: styles.pedagogyBottom,
        children: t('aboutUs:wow-3steps')
      })]
    })]
  });
};

export default Index;